import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { validateResetToken, resetPassword } from '../service/UserService';

const PasswordReset = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [tokenValid, setTokenValid] = useState(null);
  
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Validate token on component mount
    const validateToken = async () => {
      try {
        await validateResetToken(token);
        setTokenValid(true);
      } catch (error) {
        setTokenValid(false);
        setError('El enlace de recuperación es inválido o ha expirado.');
      }
    };

    if (token) {
      validateToken();
    }
  }, [token]);

  const validatePasswords = () => {
    if (password.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres.');
      return false;
    }
    
    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden.');
      return false;
    }
    
    return true;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!validatePasswords()) {
      return;
    }

    setLoading(true);

    try {
      await resetPassword(token, password);
      setMessage('Tu contraseña ha sido actualizada exitosamente.');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      setError(error.response?.data?.error || 'Error al actualizar la contraseña.');
    } finally {
      setLoading(false);
    }
  };

  if (tokenValid === null) {
    return (
      <>
        <Header searcherDisabled={true} shopLink={true} />
        <div className='container d-flex flex-column justify-content-center align-items-center login-center'>
          <div className='Login col-md-8 col-lg-4 col-11 text-center'>
            <div className="spinner-border" role="status">
              <span className="sr-only">Validando...</span>
            </div>
            <p className='mt-3'>Validando enlace de recuperación...</p>
          </div>
        </div>
      </>
    );
  }

  if (tokenValid === false) {
    return (
      <>
        <Header searcherDisabled={true} shopLink={true} />
        <div className='container d-flex flex-column justify-content-center align-items-center login-center'>
          <div className='Login col-md-8 col-lg-4 col-11 text-center'>
            <h4 className='mb-4 text-center'>Enlace Inválido</h4>
            <div className='error-message'>
              <div className='d-flex align-items-start'>
                <i className='fas fa-exclamation-triangle me-2 mt-1' style={{ fontSize: '0.875rem' }}></i>
                <small className='flex-grow-1'>
                  {error}
                </small>
              </div>
            </div>
            <p className='text-center mt-3'>
              <Link to={'/forgot-password'} style={{ fontSize: '14px', color: '#7a7a7a' }}>
                Solicitar nuevo enlace de recuperación
              </Link>
            </p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      <div className='container d-flex flex-column justify-content-center align-items-center login-center'>
        <form
          className='Login col-md-8 col-lg-4 col-11'
          onSubmit={submitHandler}
        >
          <h4 className='mb-4 text-center'>Nueva Contraseña</h4>
          <p className='text-center mb-4' style={{ fontSize: '14px', color: '#7a7a7a' }}>
            Ingresa tu nueva contraseña. Debe tener al menos 8 caracteres.
          </p>
          
          <input
            type='password'
            placeholder='Nueva contraseña'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ fontWeight: 'bold', color: 'black' }}
            className={error ? 'error-input' : ''}
            required
            minLength={8}
          />
          
          <input
            type='password'
            placeholder='Confirmar contraseña'
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={{ fontWeight: 'bold', color: 'black' }}
            className={error ? 'error-input' : ''}
            required
            minLength={8}
          />
          
          {error && (
            <div className='error-message'>
              <div className='d-flex align-items-start'>
                <i className='fas fa-exclamation-triangle me-2 mt-1' style={{ fontSize: '0.875rem' }}></i>
                <small className='flex-grow-1'>
                  {error}
                </small>
              </div>
            </div>
          )}

          {message && (
            <div className='alert alert-success py-2 mb-3' role='alert' style={{ textAlign: 'left' }}>
              <div className='d-flex align-items-start'>
                <i className='fas fa-check-circle me-2 mt-1' style={{ fontSize: '0.875rem' }}></i>
                <small className='flex-grow-1'>
                  {message}
                  <br />
                  <small>Serás redirigido al inicio de sesión en unos segundos...</small>
                </small>
              </div>
            </div>
          )}

          <button type='submit' disabled={loading || message}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Actualizando...
              </>
            ) : (
              'Actualizar contraseña'
            )}
          </button>
          
          <p className='text-center mt-3'>
            <Link to={'/login'} style={{ fontSize: '14px', color: '#7a7a7a' }}>
              Volver al inicio de sesión
            </Link>
          </p>
        </form>
      </div>
    </>
  );
};

export default PasswordReset;
